import { defineStore } from "pinia"
import { updateSubQuery, clearSubQuery } from "@evercam/shared/utils"
import { AdminApi } from "@evercam/shared/api/adminApi"
import { AdminUser } from "@evercam/shared/types"
import { useNuxtApp } from "#app"
import { useGlobalDialogStore } from "@/stores/globalDialogs"

interface UserState {
  dialog: boolean
  isLoading: boolean
  userDetails: AdminUser
  currentTab: number
  passwordResetLink: string
}

export const useUserStore = defineStore({
  id: "user",
  state: (): UserState => ({
    dialog: false,
    isLoading: false,
    userDetails: {} as AdminUser,
    currentTab: 0,
    passwordResetLink: null,
  }),
  actions: {
    openDialog(userId, shouldUpdateQuery = true) {
      useGlobalDialogStore().closeDialogs(false)
      this.dialog = true

      if (shouldUpdateQuery) {
        updateSubQuery({
          subQueryObj: { userDialog: true, userId },
          overridePreviousQuery: true,
          pushToHistory: true,
        })
      }
      this.fetchUserDetails(userId)
    },
    closeDialog() {
      if (!this.dialog) {
        return
      }

      clearSubQuery({ pushToHistory: true })
      this.$reset()
    },
    async fetchUserDetails(userId) {
      const { query } = useNuxtApp().nuxt2Context.route
      try {
        this.isLoading = true
        if (userId?.includes("@")) {
          const { items } = await AdminApi.users.getUsers({
            params: { email: userId },
          })
          userId = items[0]?.id
        }
        const { data } = await AdminApi.users.show(userId, query)
        this.userDetails = data?.userStats || {}
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async getPasswordResetLink(email) {
      await AdminApi.users
        .getUserPasswordResetLink(email)
        .then((res) => {
          this.passwordResetLink = res.passwordResetLink
        })
        .catch((error) => {
          console.log(error)
          useNuxtApp().nuxt2Context.$notifications.error({
            text: "Failed to generate password reset link!",
            error,
          })
        })
    },
  },
})
